<nav class="navbar navbar-expand-lg navbar-dark" style="background-color: #002596;">
    <ul class="navbar-nav mr-auto">
        <li class="nav-item"><a class="nav-link" routerLink="/extranet/documentos-cliente" routerLinkActive="active">Gestor documental</a></li>
        <li class="nav-item"><a class="nav-link" routerLink="/extranet/fichas-producto" routerLinkActive="active">Fichas de Productos</a></li>
        <li class="nav-item"><a class="nav-link" routerLink="/extranet/documentos-garsan" routerLinkActive="active">Documentos Generales Gar-San</a></li>
    </ul>
    <form class="form-inline">
        <button class="btn btn-outline-success" type="button" (click)="cerrarSesion()">Salir de la Extranet</button>
    </form>
</nav>